<template>
  <div :class="['lt-fyf-progress-bar-item', statusClassName]">
    <div></div>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    statusClassName: function () {
      return `lt-fyf-progress-bar-item--${this.status}`;
    },
  },
};
</script>

<style lang='scss'>

@mixin item-status-color($progress-color) {
  &::before, &::after, div {
    background-color: $progress-color;
  }
}
$shadow: 2px 2px 2px rgba(0,0,0,0.4);

.lt-fyf-progress-bar-item {
  display: flex;
  flex: 1;
  position: relative;

  &::before, &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    height: 51%;
    box-shadow: $shadow;
  }
  &::before {
    top: 0;
    transform: skewx(45deg) scalex(0.93);
  }
  &::after {
    bottom: 0;
    transform: skewx(-45deg) scalex(0.93);
  }

  div {
    display: none;
    position: absolute;
    width: 50%;
    top: 0;
    bottom: 0;
    border-radius: 3px;
    z-index: 1;
  }

  &:first-child {
    div {
      display: block;
      left: 0;
      transform: translateX(-30%);
    }
  }
  &:last-child {
    div {
      display: block;
      right: 0;
      transform: translateX(30%);
      box-shadow: $shadow;
    }
  }

  &.lt-fyf-progress-bar-item--0 { @include item-status-color($inactive-progress-color); }
  &.lt-fyf-progress-bar-item--1 { @include item-status-color($answer-a-background); }
  &.lt-fyf-progress-bar-item--2 { @include item-status-color($answer-b-background); }
  &.lt-fyf-progress-bar-item--3 { @include item-status-color($answer-c-background); }
}


</style>
